import { ProductExchangeOrSectionInfoSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/product-exchange-recommendation";
import { ReturnReasonSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/return-reasons";
import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getReturnReasonRecommendationsStream = unaryStreamRpc({
  name: "getReturnReasonRecommendationsStream" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    returnReasons: z.array(ReturnReasonSchema),
    locale: z.string().optional(),
  }),
  output: ProductExchangeOrSectionInfoSchema,
});
